import { AType, summon } from "@silversea-ssc/functional-support"
import { PriceResponseV2, SuitePayment } from "../price"
import { CheckoutFlowType } from "../checkout-flow-type"

export const ValidateCheckoutResponse = summon((F) =>
    F.interface(
        {
            suitePayment: SuitePayment(F),
            validatedPrice: PriceResponseV2(F),
            flowType: CheckoutFlowType(F),
        },
        "ValidateCheckoutResponse",
    ),
)
export type ValidateCheckoutResponse = AType<typeof ValidateCheckoutResponse>
